<div class="b-input__table">
  <div class="b-flex-column">
    <div class="b-flex-row">
      <label class="b-input__label" [innerHTML]="label" [attr.for]="id"></label>
      <div *ngIf="prefix" class="b-input__prefix-element" [class.b-input--has-label]="!!label" [innerHTML]="prefix"></div>
      <div class="b-input__input" hide-empty [class.b-input--has-label]="!!label">
        <ng-content select="f-facet[name=output-content],[facet-output-content]" no-doc></ng-content>
      </div>
      <input
        #i
        [id]="id" [name]="name" 
        [attr.type]="type"
        [disabled]="isDisabled"
        [attr.placeholder]="hasLabel || hasContent() ? '' : placeholder"

        [attr.maxlength]="maxLength"
        [attr.minlength]="minLength"
        [attr.pattern]="pattern"
        
        class="b-input__input b-input__text-input"
        [(ngModel)]="value"
        (keyup)="wKeyup.next($event)"
        (change)="wChange.next(value)"
        (focus)="wFocus.next($event)"
        (blur)="wBlur.next($event)"
      />
      <div *ngIf="suffix" class="b-input__suffix-element" [class.b-input--has-label]="!!label" [innerHTML]="suffix"></div>
      <div *ngIf="isPassword" class="b-show-pwd" [ngClass]="{'b-hide-pwd': togglePassword}" (click)="togglePwd()"></div>
    </div>
    <div hide-empty>
      <ng-content select="f-facet[name=content],f-facet[content],[facet-content]"></ng-content>
    </div>
  </div>
  <div hide-empty class="b-input__button-wrapper" [class.b-always-active]="buttonsAlwaysActive">
    <ng-content select="f-facet[name=buttons],[facet-buttons]" description="Action button"></ng-content>
  </div>
</div>
<!-- it is a bit twisted, but we want to display dropdown differently in case it contains text (as opposed to plain link array) -->
<f-facet-info [isDropdown]="true">
  <ng-content select="f-facet[name=dropdown],[facet-dropdown]" no-doc></ng-content>
</f-facet-info>
<f-facet-info [isDropdown]="true" [isNotice]="true">
  <ng-content select="f-facet[name=dropdown-notice],[facet-dropdown-notice]" no-doc></ng-content>
</f-facet-info>
<f-facet-info [isError]="true">
  {{ error
  }}<ng-content select="f-facet[name=error],[facet-error]" description="Display error message"></ng-content>
</f-facet-info>
<f-facet-info *ngIf="capsLockLabel">
  {{ capsLockLabel }}
</f-facet-info>
<f-facet-info>
  {{ info }}<ng-content select="f-facet[name=info],[facet-info]" description="Display info message"></ng-content>
</f-facet-info>
